import type { AjaxError } from 'rxjs';
import { Observable } from 'rxjs';
import { get } from '@helpcenter/ajax';
import { getMeta } from '@helpcenter/meta';
import type { ExternaLinksAjaxResponse, ExternalLinksReponse } from './types';

export const fetchExternalLinks = (projectId: number): Observable<ExternalLinksReponse> => {
	const tenantId = getMeta('tenant-id') || '';
	const url = `/gateway/api/jira/help-kosh/cloudid/${tenantId}/api/v1/external-links/project/${projectId}`;
	// Suppressing existing violation. Please fix this.
	// eslint-disable-next-line @typescript-eslint/no-unsafe-return
	return get(url)
		.map(({ response }: ExternaLinksAjaxResponse) => response)
		.catch((e: AjaxError) => {
			return Observable.throw(e);
		});
};
